import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { api } from "./api";

const AuthCtx = createContext(null);
const SiteCtx = createContext({});
export const STAFF = ["admin", "manager", "advocate", "accounting", "marketing"];

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [site, setSite] = useState({});
  const loadSite = useCallback(async () => {
    const { data } = await api.get("/public/settings");
    setSite(data);
    if (data.colors?.primary) document.documentElement.style.setProperty("--brand", data.colors.primary);
    if (data.colors?.accent) document.documentElement.style.setProperty("--brand-accent", data.colors.accent);
  }, []);
  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
    loadSite().catch(() => {});
  }, [loadSite]);
  const login = async (email, password, code) => {
    const { data } = await api.post("/auth/login", { email, password, code: code || undefined });
    if (data.mfa_required) return data;
    localStorage.setItem("aura_token", data.token);
    setUser(data.user);
    return data;
  };
  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("aura_token", data.token);
    setUser(data.user);
    return data;
  };
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("aura_token");
    setUser(false);
  };
  return (
    <AuthCtx.Provider value={{ user, login, register, logout, setUser }}>
      <SiteCtx.Provider value={{ site, reloadSite: loadSite }}>{children}</SiteCtx.Provider>
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
export const useSite = () => useContext(SiteCtx);
export const isStaff = (u) => u && STAFF.includes(u.role);

export function RequireAuth({ children, roles }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <div className="p-16 text-center text-slate-500" data-testid="auth-loading">Loading…</div>;
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname + loc.search)}`} replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={isStaff(user) ? "/staff" : "/portal"} replace />;
  return children;
}
